export const APP_PREFIX = '__va__';
export const MESSAGES_CONTENT_ID = 'messages-content';
export const IFRAME_CONTENT_ID = 'va-content';

// keyboard
export const KEY_CODE_ENTER = 13;
export const KEY_CODE_ARROW_UP = 38;
export const KEY_CODE_ARROW_DOWN = 40;

// network
export const NETWORK_ONLINE = 'online';
export const NETWORK_SLOW = 'slow';
export const NETWORK_OFFLINE = 'offline';
export const NETWORK_QUALITY_FULLSCREEN = 'fullscreen';
export const NETWORK_QUALITY_EMBEDDED = 'embedded';
export const NETWORK_PING_URL = 'https://ipv4.icanhazip.com/';
export const NETWORK_PING_TIMEOUT = 5000;
export const NETWORK_PING_INTERVAL = 5000;
export const NETWORK_SLOW_RESPONSE_DURATION = 1500;

// chat window
export const CHAT_WINDOW_MODE_CLOSED = 'closed';
export const CHAT_WINDOW_MODE_DEFAULT = 'default';
export const CHAT_WINDOW_MODE_EXTENDED = 'extended';
export const CHAT_WINDOW_MODE_FULLSCREEN = 'fullscreen';
export const CHAT_WINDOW_MODE_HALFSCREEN = 'halfscreen';
export const CHAT_WINDOW_MODE_MINIMIZED = 'minimized';
export const CHAT_WINDOW_VARIANT_EMBEDDED = 'embedded';
export const CHAT_WINDOW_VARIANT_FULLSCREEN = 'fullscreen';
export const CHAT_WINDOW_VARIANT_POP_IN = 'pop-in';

// default font
export const DEFAULT_IMPORT_FONT_FAMILY =
  'https://fonts.googleapis.com/css?family=Lato:400,400i,700&display=swap';
export const DEFAULT_FONT_FAMILY = "'Lato', sans-serif";

// message types
export const MESSAGE_TYPE_SENT = 1;
export const MESSAGE_TYPE_RECEIVED = 2;

// message tree types
export const MESSAGE_TREE_TYPE_LINK_TO_URL = 1;
export const MESSAGE_TREE_TYPE_LINK_TO_MQA = 2;
export const MESSAGE_TREE_TYPE_LINK_TO_GPF = 3;
export const MESSAGE_TREE_TYPE_COMMENT = 5;
export const MESSAGE_TREE_TYPE_BRANCH = 6;
export const MESSAGE_TREE_TYPE_REDIRECT = 7;
export const MESSAGE_TREE_TYPE_ALTERNATE = 11;
export const MESSAGE_TREE_TYPE_CONTEXTUAL = 12;

// message order types
export const MESSAGE_ORDER_TYPE_FIRST = 'first';
export const MESSAGE_ORDER_TYPE_MIDDLE = 'middle';
export const MESSAGE_ORDER_TYPE_LAST = 'last';

// log types
export const LOG_TYPE_INFO = 0;
export const LOG_TYPE_WARN = 1;
export const LOG_TYPE_DEBUG = 2;
export const LOG_TYPE_ERROR = 99;

// notification types
export const NOTIFICATION_TYPE_INFO = 1;
export const NOTIFICATION_TYPE_WARN = 2;
export const NOTIFICATION_TYPE_ERROR = 3;

// gpf types
export const GPF_TYPE_TREE = 'TREE';

// positions
export const POSITION_TOP = 'top';
export const POSITION_RIGHT = 'right';
export const POSITION_BOTTOM = 'bottom';
export const POSITION_LEFT = 'left';

// animation names
export const FADE_IN = 'fadeIn';
export const FADE_IN_LEFT = 'fadeInLeft';
export const FADE_IN_RIGHT = 'fadeInRight';
export const FADE_IN_UP = 'fadeInUp';
export const FADE_OUT_RIGHT = 'fadeOutRight';
export const FADE_OUT_UP = 'fadeOutUp';

// scroll style
export const SCROLLBAR_TOP = 4;

// menu
export const MENU_ITEM_ACTION = 'action';
export const MENU_ITEM_LINK = 'link';
export const MENU_ITEM_SPACER = 'spacer';
export const MENU_ITEM_LANGUAGE = 'language';

// main menu functions
export const MAIN_MENU_ITEM_SEND_TRANSCRIPT = 'sendTranscript'; // not yet used
export const MAIN_MENU_ITEM_GET_HOT_TOPICS = 'getHotTopics';
export const MAIN_MENU_ITEM_GET_TOP_QUESTIONS = 'getTopQuestions'; // not yet used
export const MAIN_MENU_ITEM_PRINT_MESSAGES = 'printMessages';
export const MAIN_MENU_ITEM_SURVEY = 'survey'; // not yet used
export const MAIN_MENU_ITEM_DELETE_CONVERSATION = 'deleteConversation'; // not yet used

// launcher variants
export const LAUNCHER_VARIANT_FLOATING = 'floating';
export const LAUNCHER_VARIANT_ICON = 'icon';
export const LAUNCHER_VARIANT_SIDETAB = 'sidetab';
export const LAUNCHER_VARIANT_HIDDEN = 'hidden';

// pubsub-js topics
export const PUBSUB_APP_INITIALIZED = 'appInitialized';
export const PUBSUB_CHAT_WINDOW_OPEN = 'open';
export const PUBSUB_CHAT_WINDOW_OPENED = 'opened';
export const PUBSUB_CHAT_WINDOW_CLOSE = 'close';
export const PUBSUB_CHAT_WINDOW_CLOSED = 'closed';
export const PUBSUB_CHAT_WINDOW_MINIMIZED = 'minimized';
export const PUBSUB_LAUNCHER_BUTTON_CLICKED = 'launcherButtonClicked';
export const PUBSUB_IDLE = 'idle';
export const PUBSUB_GET_STORE = 'getStore';
export const PUBSUB_STORE = 'store';
export const PUBSUB_AB = 'AB';
export const PUBSUB_LIVE_CHAT = 'liveChat';
export const PUBSUB_LIVE_CHAT_SUGGEST = 'liveChat.suggest';
export const PUBSUB_LIVE_CHAT_SUGGEST_THUMBSDOWN = 'liveChat.suggestThumbsDown';
export const PUBSUB_LIVE_CHAT_START = 'liveChat.start';
export const PUBSUB_LIVE_CHAT_CLOSED = 'liveChat.closed';
export const PUBSUB_LIVE_CHAT_CREATED = 'liveChat.created';
export const PUBSUB_LIVE_CHAT_BUTTON_CLICKED = 'liveChat.buttonClicked';
export const PUBSUB_AB_DISPLAYED = 'AB.displayed';
export const PUBSUB_AB_WIN = 'AB.win';
export const PUBSUB_MESSAGE = 'message';
export const PUBSUB_MESSAGE_TEXT = 'message.text';
export const PUBSUB_MESSAGE_HTML = 'message.html';
export const PUBSUB_MESSAGE_HTML_WITH_SCROLL = 'message.htmlScroll';
export const PUBSUB_SURVEY = 'survey';
export const PUBSUB_CLEAR_CONVERSATION = 'clearConversation';

// overlap menu
export const OVERLAP_MENU_LIVE_CHAT_FUNCTION = 'liveChat';

// language IDs
export const LANGUAGES = [
  {
    id: 1,
    name: 'en',
    description: 'English'
  },
  {
    id: 2,
    name: 'ms',
    description: 'Malay'
  },
  {
    id: 3,
    name: 'zh-Hans',
    description: 'Chinese Simplified'
  },
  {
    id: 4,
    name: 'ta',
    description: 'Tamil'
  },
  {
    id: 5,
    name: 'vo',
    description: 'Voice'
  },
  {
    id: 6,
    name: 'bo',
    description: 'Bot'
  },
  {
    id: 7,
    name: 'fr',
    description: 'French'
  },
  {
    id: 8,
    name: 'de',
    description: 'German'
  },
  {
    id: 9,
    name: 'it',
    description: 'Italian'
  },
  {
    id: 10,
    name: 'pl',
    description: 'Polish'
  },
  {
    id: 11,
    name: 'pt',
    description: 'Portuguese'
  },
  {
    id: 12,
    name: 'ru',
    description: 'Russian'
  },
  {
    id: 13,
    name: 'es',
    description: 'Spanish'
  },
  {
    id: 14,
    name: 'zh-Hant',
    description: 'Chinese Traditional'
  },
  {
    id: 15,
    name: 'ja',
    description: 'Japanese'
  },
  {
    id: 16,
    name: 'tr',
    description: 'Turkish'
  },
  {
    id: 17,
    name: 'el',
    description: 'Greek'
  },
  {
    id: 18,
    name: 'hu',
    description: 'Hungarian'
  },
  {
    id: 19,
    name: 'ro',
    description: 'Romanian'
  },
  {
    id: 20,
    name: 'th',
    description: 'Thai'
  },
  {
    id: 21,
    name: 'ko',
    description: 'Korean'
  },
  {
    id: 22,
    name: 'nl',
    description: 'Dutch'
  }
];

export const LANGUAGE_ZH = 'zh-Hans';
